<template>
  <div class="ui form">
    <h4 class="ui dividing header">{{ $t("general info") }}</h4>
    <div class="field">
      <label for>{{ $t("wsdl url") }}</label>
      <input type="text" name="wsdl_url" v-model="wsdl_url" />
    </div>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("access number") }}</label>
        <input type="text" name="access_number" v-model="access_number" />
      </div>
      <div class="field">
        <label for>{{ $t("currency") }}</label>
        <div class="ui search selection dropdown" ref="currency_dropdown">
          <input type="hidden" name="currency" :value="currency" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
    </div>
    <h4 class="ui dividing header">{{ $t("issuer") }}</h4>
    <div class="three fields">
      <div class="field">
        <label for>{{ $t("email") }}</label>
        <input type="text" name="issuer_email" v-model="issuer_email" />
      </div>
      <div class="field">
        <label for>{{ $t("establishment code") }}</label>
        <input
          type="text"
          name="issuer_establishment_code"
          v-model="issuer_establishment_code"
        />
      </div>
      <div class="field">
        <label for>{{ $t("nit") }}</label>
        <input type="text" name="issuer_nit" v-model="issuer_nit" />
      </div>
    </div>
    <div class="three fields">
      <div class="field">
        <label for>{{ $t("comercial name") }}</label>
        <input
          type="text"
          name="issuer_comercial_name"
          v-model="issuer_comercial_name"
        />
      </div>
      <div class="field">
        <label for>{{ $t("iva affiliation") }}</label>
        <input
          type="text"
          name="issuer_iva_affiliation"
          v-model="issuer_iva_affiliation"
        />
      </div>
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="issuer_name" v-model="issuer_name" />
      </div>
    </div>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("address") }}</label>
        <input type="text" name="issuer_address" v-model="issuer_address" />
      </div>
      <div class="field">
        <label for>{{ $t("zip code") }}</label>
        <input type="text" name="issuer_zip_code" v-model="issuer_zip_code" />
      </div>
    </div>
    <div class="three fields">
      <div class="field">
        <label for>{{ $t("country") }}</label>
        <input type="text" name="issuer_country" v-model="issuer_country" />
      </div>
      <div class="field">
        <label for>{{ $t("department") }}</label>
        <input
          type="text"
          name="issuer_department"
          v-model="issuer_department"
        />
      </div>
      <div class="field">
        <label for>{{ $t("municipality") }}</label>
        <input
          type="text"
          name="issuer_municipality"
          v-model="issuer_municipality"
        />
      </div>
    </div>
    <h4 class="ui dividing header">{{ $t("g4s membership") }}</h4>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("requestor") }}</label>
        <input type="text" name="g4s_requestor" v-model="g4s_requestor" />
      </div>
      <div class="field">
        <label for>{{ $t("user") }}</label>
        <input type="text" name="g4s_user" v-model="g4s_user" />
      </div>
    </div>
    <h4 class="ui dividing header">{{ $t("phrases") }}</h4>
    <generic-container
      :title="$t('phrases')"
      icon="mountain"
      :show_plus="true"
      @add="add_phrase"
    >
      <div class="ui list">
        <div class="item" v-for="(phrase, idx) in phrases" :key="idx">
          <i class="check icon"></i>
          <div class="content">
            <div
              class="ui mini icon red right floated button"
              @click="remove_phrase(idx)"
            >
              <i class="trash icon"></i>
            </div>
            <!-- <a class="header"
              >{{ $t("phrase type") }} {{ phrase.phrase_code }}
              <small>| {{ $t("stage code") }} {{ phrase.stage_code }}</small>
            </a>
            <div class="description"></div> -->
            <div class="fields">
              <div class="two field">
                <label for="" v-show="idx == 0">{{ $t("phrase type") }}</label>
                <input type="text" v-model="phrases[idx].phrase_code" />
              </div>
              <div class="field">
                <label for="" v-show="idx == 0">{{ $t("stage code") }}</label>
                <input type="text" v-model="phrases[idx].stage_code" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </generic-container>
    <h4 class="ui dividing header">{{ $t("default receiver values") }}</h4>
    <div class="fields">
      <div class="six wide field">
        <label for>{{ $t("nit") }}</label>
        <input
          type="text"
          name="default_receiver_nit"
          v-model="default_receiver_nit"
        />
      </div>
      <div class="six wide field">
        <label for>{{ $t("name") }}</label>
        <input
          type="text"
          name="default_receiver_name"
          v-model="default_receiver_name"
        />
      </div>
      <div class="four wide field">
        <label for>{{ $t("email") }}</label>
        <input
          type="text"
          name="default_receiver_email"
          v-model="default_receiver_email"
        />
      </div>
    </div>
    <div class="fields">
      <div class="eleven wide field">
        <label for>{{ $t("address") }}</label>
        <input
          type="text"
          name="issuer_address"
          v-model="default_receiver_address"
        />
      </div>
      <div class="five wide field">
        <label for>{{ $t("zip code") }}</label>
        <input
          type="text"
          name="default_receiver_zip_code"
          v-model="default_receiver_zip_code"
        />
      </div>
    </div>
    <div class="three fields">
      <div class="field">
        <label for>{{ $t("country") }}</label>
        <input
          type="text"
          name="default_receiver_country"
          v-model="default_receiver_country"
        />
      </div>
      <div class="field">
        <label for>{{ $t("department") }}</label>
        <input
          type="text"
          name="default_receiver_department"
          v-model="default_receiver_department"
        />
      </div>
      <div class="field">
        <label for>{{ $t("municipality") }}</label>
        <input
          type="text"
          name="default_receiver_municipality"
          v-model="default_receiver_municipality"
        />
      </div>
    </div>
  </div>
</template>

<script>
import currency from "@/currency";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "G4SBilling",
  components: { GenericContainer },
  props: {
    setup_in: Object,
  },
  data() {
    return {
      wsdl_url: "",
      access_number: "",
      currency: "GTQ",
      issuer_establishment_code: "",
      issuer_comercial_name: "",
      issuer_iva_affiliation: "",
      issuer_nit: "",
      issuer_email: "",
      issuer_name: "",
      issuer_address: "",
      issuer_zip_code: "",
      issuer_municipality: "",
      issuer_department: "",
      issuer_country: "",
      g4s_requestor: "",
      g4s_user: "",
      default_receiver_nit: "",
      default_receiver_email: "",
      default_receiver_name: "",
      default_receiver_address: "",
      default_receiver_zip_code: "",
      default_receiver_municipality: "",
      default_receiver_department: "",
      default_receiver_country: "",
      phrases: [],
    };
  },
  mounted() {
    let vm = this;
    let curr = Object.keys(currency).map((k) => {
      return {
        value: currency[k].code,
        name: `${currency[k].name} (${currency[k].code})`,
      };
    });

    if (vm.setup_in) {
      vm.wsdl_url = vm.setup_in.wsdl_url;
      vm.access_number = vm.setup_in.access_number;
      vm.currency = vm.setup_in.currency;
      vm.issuer_establishment_code = vm.setup_in.issuer_establishment_code;
      vm.issuer_comercial_name = vm.setup_in.issuer_comercial_name;
      vm.issuer_iva_affiliation = vm.setup_in.issuer_iva_affiliation;
      vm.issuer_email = vm.setup_in.issuer_email;
      vm.issuer_nit = vm.setup_in.issuer_nit;
      vm.issuer_name = vm.setup_in.issuer_name;
      vm.issuer_address = vm.setup_in.issuer_address;
      vm.issuer_zip_code = vm.setup_in.issuer_zip_code;
      vm.issuer_country = vm.setup_in.issuer_country;
      vm.issuer_department = vm.setup_in.issuer_department;
      vm.issuer_municipality = vm.setup_in.issuer_municipality;
      vm.default_receiver_email = vm.setup_in.default_receiver_email;
      vm.default_receiver_nit = vm.setup_in.default_receiver_nit;
      vm.default_receiver_name = vm.setup_in.default_receiver_name;
      vm.default_receiver_address = vm.setup_in.default_receiver_address;
      vm.default_receiver_zip_code = vm.setup_in.default_receiver_zip_code;
      vm.default_receiver_country = vm.setup_in.default_receiver_country;
      vm.default_receiver_department = vm.setup_in.default_receiver_department;
      vm.default_receiver_municipality =
        vm.setup_in.default_receiver_municipality;
      vm.g4s_requestor = vm.setup_in.g4s_requestor;
      vm.g4s_user = vm.setup_in.g4s_user;
      if (vm.setup_in.phrases) vm.phrases = vm.setup_in.phrases;
    }

    window
      .jQuery(vm.$refs.currency_dropdown)
      .dropdown("setup menu", { values: curr })
      .dropdown({
        onChange(value) {
          vm.currency = value;
        },
      });
  },
  methods: {
    emit() {
      this.$emit("update", {
        wsdl_url: this.wsdl_url,
        access_number: this.access_number,
        currency: this.currency,
        issuer_establishment_code: this.issuer_establishment_code,
        issuer_comercial_name: this.issuer_comercial_name,
        issuer_iva_affiliation: this.issuer_iva_affiliation,
        issuer_email: this.issuer_email,
        issuer_nit: this.issuer_nit,
        issuer_name: this.issuer_name,
        issuer_address: this.issuer_address,
        issuer_zip_code: this.issuer_zip_code,
        issuer_country: this.issuer_country,
        issuer_department: this.issuer_department,
        issuer_municipality: this.issuer_municipality,
        default_receiver_email: this.default_receiver_email,
        default_receiver_nit: this.default_receiver_nit,
        default_receiver_name: this.default_receiver_name,
        default_receiver_address: this.default_receiver_address,
        default_receiver_zip_code: this.default_receiver_zip_code,
        default_receiver_country: this.default_receiver_country,
        default_receiver_department: this.default_receiver_department,
        default_receiver_municipality: this.default_receiver_municipality,
        g4s_requestor: this.g4s_requestor,
        g4s_user: this.g4s_user,
        phrases: this.phrases,
      });
    },
    add_phrase() {
      this.phrases.push({ stage_code: "1", phrase_code: "1" });
    },
    remove_phrase(idx) {
      this.phrases.splice(idx, 1);
    },
  },
  watch: {
    wsdl_url() {
      this.emit();
    },
    access_number() {
      this.emit();
    },
    currency() {
      this.emit();
    },
    issuer_establishment_code() {
      this.emit();
    },
    issuer_comercial_name() {
      this.emit();
    },
    issuer_iva_affiliation() {
      this.emit();
    },
    issuer_email() {
      this.emit();
    },
    issuer_nit() {
      this.emit();
    },
    issuer_name() {
      this.emit();
    },
    issuer_address() {
      this.emit();
    },
    issuer_zip_code() {
      this.emit();
    },
    issuer_country() {
      this.emit();
    },
    issuer_department() {
      this.emit();
    },
    issuer_municipality() {
      this.emit();
    },
    default_receiver_email() {
      this.emit();
    },
    default_receiver_nit() {
      this.emit();
    },
    default_receiver_name() {
      this.emit();
    },
    default_receiver_address() {
      this.emit();
    },
    default_receiver_zip_code() {
      this.emit();
    },
    default_receiver_country() {
      this.emit();
    },
    default_receiver_department() {
      this.emit();
    },
    default_receiver_municipality() {
      this.emit();
    },
    g4s_requestor() {
      this.emit();
    },
    g4s_user() {
      this.emit();
    },
  },
};
</script>
